<template>
  <div>
    <Transition name="fade" mode="out-in">
      <Component
          :is="component"
          :details="details"
          :areas="areas"
          :projects="projects"
          @changeDetail="swapView($event)"
      />
    </Transition>
  </div>
</template>

<script>
  import EmployeeList from './EmployeeList.vue';
  import EmployeeDetails from './EmployeeDetails.vue';
  import {backend} from "../../backend";

  export default{
      name: 'EmployeeSwap',
      components: {
          'employee-list': EmployeeList,
          'employee-details': EmployeeDetails
      },
      data: function (){
          return {
              areas: [],
              projects: [],
              details: {},
              component: 'employee-list'
          }
      },
      created () {
          this.getAreas();
          this.getProjects();
      },
      methods: {
          swapView: function (employeeDetails) {
              this.component = employeeDetails.component_change;
              this.details = employeeDetails.details;
              this.$emit('toggleMenuVisibility')
          },
          getAreas: function () {
              backend.getAreas().then(response => {
                  this.areas = response.data;
              })
          },
          getProjects: function() {
            backend.getProjects().then(response =>{
                this.projects = response.data;
            })
          },
      }
  }
</script>



// WEBPACK FOOTER //
// EmployeeViewSwap.vue?1cdfed18